import { render, staticRenderFns } from "./TableMarkBarem.vue?vue&type=template&id=626c4a4e&scoped=true"
import script from "./TableMarkBarem.vue?vue&type=script&lang=js"
export * from "./TableMarkBarem.vue?vue&type=script&lang=js"
import style0 from "./TableMarkBarem.vue?vue&type=style&index=0&id=626c4a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626c4a4e",
  null
  
)

export default component.exports